<template>
  <div class="index_h5">
    <el-popover width="220" placement="left-end" trigger="click">
      <template #reference>
        <img class="tellUs_icon" referrerpolicy="no-referrer"
          src="../../assets/images/index/lianxi.png" />
      </template>
      <div class="tell_us_popup flex-col">
          <div class="flex-row tell_us_li" @click="toHref('https://mall.nfstzx.com/industry/dataAcquisitionForm?id=7120700956034836512&ltype=plat_bigdata', '_blank')">
            <img class="image_9" referrerpolicy="no-referrer"
              src="../../assets/images/index/jiameng.png" />
            <div class="text-group_5 flex-col">
              <span class="text_5">我要加盟</span>
              <span class="text_6 ">留下信息加盟我们</span>
            </div>
          </div>
          <div class="flex-row tell_us_li">
            <img class="image_9" referrerpolicy="no-referrer"
              src="../../assets/images/index/dianhua.png" />
            <div class="text-group_5 flex-col">
              <span class="text_5">联系电话</span>
              <a class="text_5" :href="'tel:'+platInfo.tel">{{platInfo.tel}}</a>
            </div>
          </div>
          <div class="flex-row tell_us_li">
            <img class="image_9" referrerpolicy="no-referrer"
              src="../../assets/images/index/zhiwen.png" />
            <div class="text-group_5 flex-col">
              <span class="text_5">扫码关注</span>
              <div
                class="img-box"
                @touchstart="onTouchStart"
                @touchmove="onTouchMove"
                @touchend="onTouchEnd"
              >
                <!-- 真实展示的图片 -->
                 <img class="image_10" ref="imgRef" referrerpolicy="no-referrer" @dragstart.prevent
                  :src="commenUrl+platInfo.gzh"/>
              </div>
              
              <div class="text_7">-长按保存关注-</div>
            </div>
          </div>
      </div>
    </el-popover>

    <!-- <div class="mouse_icon_wrapper">
      <img class="mouse_icon" referrerpolicy="no-referrer"
        src="https://lanhu-oss-proxy.lanhuapp.com/SketchPng455eeafa6689709214e9c6aaeba751278fafe428b8090085ffdaee3ed1d5a889" />
    </div> -->
    <section class="section_1_1">
      <div class="page flex-col">
        <div class="section_2 flex-col">
          <div class="flex-col">
            <swiper
              :modules="modules"
              :slides-per-view="1"
              :space-between="0"
              :pagination="{ clickable: true }"
              :autoplay="{ delay: 3000, disableOnInteraction: false }"
              :loop="true"
              @swiper="onSwiper"
              @slideChange="onSlideChange"
              class="my-banner-swiper"
            >
              <swiper-slide v-for="(banner, index) in bannerList" :key="index">
                <div class="swiperBack" :style="{ backgroundImage: `url(${commenUrl + banner.tp.split(',')[0]})`}">
                  <img v-if="banner.tp.split(',')[1]" :src="commenUrl + banner.tp.split(',')[1]" class="banner-img" />
                </div>
                
              </swiper-slide>

            </swiper>
          </div>
          <div class="block_1 flex-col">
            <span class="text_4">核心服务</span>
            <div class="nav">
              <span :class="[selectZxIndex == wdzxIndex ? 'active' : '']" @click="selectZxIndex = wdzxIndex"
                v-for="(wdzxLi, wdzxIndex) in wdzxList">{{ wdzxLi.flmc }}</span>
            </div>
            <div class="hxywbk_list" v-if="wdzxList && wdzxList.length > 0">
              <div class="section_2 flex-col" v-for="(wdzxContent, index) in wdzxList[selectZxIndex].items">
                <div class="image-text_8 flex-row">
                  <img class="label_1" referrerpolicy="no-referrer" :src="commenUrl + wdzxContent.zxtb" />
                  <div class="text-group_13 flex-col">
                    <div class="text_10">{{ wdzxContent.zxmc }}</div>
                    <div class="text_11">{{ wdzxContent.zxjs }}</div>
                    <div class="card-action" v-if="handleBtn(wdzxList[selectZxIndex].items[index].items).length > 0">
                      <span @click="toHref(btnValue.lj, btnValue.ljlx)" :class="['wui-color-' + themeColor]"
                        v-for="(btnValue, btnIndex) in handleBtn(wdzxList[selectZxIndex].items[index].items)">
                        {{ wdzxList[selectZxIndex].items[index].items.length > 1 ? btnValue.mc : '了解详情' }}
                      </span>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section_2_2">
      <div class="page flex-col">
        <div class="group_8 flex-col">
          <span class="text_4">客户群</span>
          <div class="customers_list">
            <div class="group_4 flex-row justify-end" v-for="customersLi in customers" :key="customersLi.id">
              <div class="image-text_5 flex-row">
                <div class="text-group_8 flex-col">
                  <span class="text_8">{{ customersLi.overview }}</span>
                  <!-- <span class="text_9">产业根基</span> -->
                  <span class="text_10">{{ customersLi.content }}</span>
                </div>
                <div class="section_1 flex-col">
                  <img :src="customersLi.logo" alt="">
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>

    <section class="section_4_4">
      <div class="page flex-col">
        <div class="group_4 flex-col">
          <div class="group_5 flex-row justify-between">
            <span class="text_4" @click="toHref('serviceCase')">服务案例</span>
            <!-- <div class="text-wrapper_3 flex-col">
              查看更多
            </div> -->
          </div>
          <div class="group_6 flex-col">
            <div class="image-text_1" v-for="partner in serverCase">
              <div class="flex-row justify-between">
                <div class="text-group_5 flex-col">
                  <span class="text_5 line-height-2">{{ partner.title }}</span>
                  <span class="text_6 line-height-2">{{ partner.articleAbstract }}</span>
                </div>
                <div class="group_2 flex-col">
                  <img :src="commenUrl + partner.pictureUrl" />
                </div>
              </div>
              <div class="ljxq" @click="toHref('serviceCase?id='+partner.id)">了解详情</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section_5_5">
      <div class="page flex-col">
        <div class="box_11 flex-col">
          <span class="text_6">平台发展合作联盟体系</span>
        </div>
        <div class="partners-grid content-center">
          <div class="partner-logo" v-for="(partner, index) in partners" :key="index">
            <img v-if="partner.linkIcon" :src="commenUrl + partner.linkIcon" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script setup>
import { ref, onMounted, getCurrentInstance } from 'vue'
import { useRouter } from 'vue-router'
import { Swiper, SwiperSlide } from 'swiper/vue';// 导入 Swiper 样式
// 只包含核心样式：
import 'swiper/css';
// 如果使用了分页器(Pagination)、导航(Navigation)等模块，需要额外导入样式
import 'swiper/css/pagination';
import 'swiper/css/navigation'; 
import 'swiper/css/autoplay'; 

// 导入需要的模块（例如：分页、自动播放）
import { Pagination, Autoplay } from 'swiper/modules';
const router = useRouter();
const { proxy } = getCurrentInstance();
const modules = [Pagination, Autoplay];
const props = defineProps({
  platInfo: {
      type: Object,
      default: {}
  }
})
const customers = ref([
  {
    title: '',
    overview: '农业服务供应商',
    content: '提供农业技术、检测、认证、物流等专业服务的机构。',
    logo: require('@/assets/images/index/khqt-1.png'),
    icon: require('@/assets/images/index/khqt-icon-1.png'),
    link: ''
  },
  {
    title: '',
    overview: '国际农业贸易伙伴',
    content: '境外购买中国农业产品或服务的法人实体。',
    logo: require('@/assets/images/index/khqt-2.png'),
    icon: require('@/assets/images/index/khqt-icon-2.png'),
    link: ''
  },
  {
    title: '',
    overview: '农业产品与生产资料供应商',
    content: '从事农产品生产销售或农资农机供应的市场主体。',
    logo: require('@/assets/images/index/khqt-3.png'),
    icon: require('@/assets/images/index/khqt-icon-3.png'),
    link: ''
  },
  {
    title: '',
    overview: '农业公共采购主体',
    content: '包括各级农业农村部门、事业单位及其他使用财政资金采购农业服务的公共机构。',
    logo: require('@/assets/images/index/khqt-4.png'),
    icon: require('@/assets/images/index/khqt-icon-4.png'),
    link: ''
  }
])
const serverCase = ref([])
const getServerList = () => {
  proxy.$request({
    url: "PORTAL_W_INDUSTRYARTICLEMAGE_FINDPAGELIST",
    method: "post",
    data: { portalType: 'nfstzxcases', userSort: '1' }
  }).then((res) => {
    if (res.data.code == "000") {
      serverCase.value = res.data.result.list.splice(0, 4);
    }
  }).catch((err) => {
    console.log(err)
  });
}

// 获取产业联盟
const partners = ref([])
const getLink = (linkType) => {
  // 获取0:友情链接1:热门服务2:合作联系3:合作联盟
  proxy.$request({
    url: "PROTAL_N_INDUSTRYFRIENDLY_FINDLIST",
    method: "post",
    data: { "isShow": "0", "portalType": proxy.getConfig().portalType, linkType: linkType }
  }).then((res) => {
    if (res.data.code == "000") {
      partners.value = res.data.result;
    }
  }).catch((err) => {
    console.log(err)
  });
}
// 商通中心五大核心业务
const wdzxList = ref([])
const selectZxIndex = ref(0)
const getWdhx = () => {
  proxy.$request({
    url: "SIMPLE_N_QPSTZX_INDEX_WDZXPZLIST",
    method: "post",
    data: { "portalType": proxy.getConfig().portalType }
  }).then((res) => {
    if (res.data.code == "000") {
      wdzxList.value = res.data.result
    }
  }).catch((err) => {
    console.log(err)
  });
}
// 过滤按钮
const handleBtn = (array) => {
  if (!array || array.length <= 0) return []
  return array.filter(item => item.mcsfxs === '显示')
    .slice(0, 3);
}

//长按图片义务处理

const delay = 600
const imgRef = ref(null)
let timer = null
let moved = false           // 手指是否移动过

/* ---------- 1. 长按检测 ---------- */
function onTouchStart () {
  moved = false
  timer = setTimeout(() => {
    timer = null
    saveImage()             // 真正保存
  }, delay.value)
}
function onTouchMove () {
  moved = true              // 只要移动就取消长按
}
function onTouchEnd () {
  if (timer) {              // 600 ms 内抬手 → 取消
    clearTimeout(timer)
    timer = null
  }
}

/* ---------- 2. 保存逻辑 ---------- */
function saveImage() {
  const img = imgRef.value
  if (!img || moved) return

  try {
    // 离屏 canvas
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    canvas.width = img.naturalWidth || img.width
    canvas.height = img.naturalHeight || img.height
    ctx.drawImage(img, 0, 0)

    // 核心：导出失败会抛 SecurityError
    canvas.toBlob(blob => {
      if (!blob) return
      const url = URL.createObjectURL(blob)
      const a = Object.assign(document.createElement('a'), {
        href: url,
        download: img.alt || 'image.png'
      })
      document.body.appendChild(a)
      a.click()
      a.remove()
      URL.revokeObjectURL(url)
    }, 'image/png')
  } catch (e) {
    // 开发/测试环境静默跳过，生产可埋点
    console.warn('[saveImage] 跨域导致画布污染，已忽略保存。', e)
    // 如需给用户提示，可在此处弹 Toast：
    // Toast('当前环境无法保存，请长按系统菜单保存')
  }
}

// 判断是否为完整URL
const isFullUrl = (url) => {
    return /^https?:\/\//.test(url);
};
const toHref = (url, type, toType,e) => {
    if(toType=='0'||!toType){
        if (!url) {
            return;
        }
        if (type === '_blank') {
            // 新标签页打开
            proxy.tool.openWindow(url);
        } else if (isFullUrl(url)) {
            // 完整URL，使用页面跳转
            window.location.href = url;
        } else {
            // 相对路径，使用路由跳转
            router.push(url);
        }
    }else if(toType=='1'){
        let fileUrl = e.fileUrl
        const url = router.resolve({
            path: 'Pdfcomp',
        });
        let obj = {
            page: proxy.commenUrl + JSON.parse(fileUrl)[0].url,
        };
        let params = btoa(JSON.stringify(obj))
        url.href += '?params=' + params
        proxy.tool.openWindow(url.href);
    }else if(toType=='2'){
        let fileUrl = e.imgUrl
        try {
            srcList.value = [proxy.commenUrl+JSON.parse(fileUrl).url[0].url]
            showPreview.value = true;
        } catch (error) {
            srcList.value = [proxy.commenUrl+fileUrl]
            showPreview.value = true;
        }
    }
    
};
// 获取banner

const bannerList = ref([])
function getBanner(){
  proxy.$request({
    url:"N_QPSTZX_BANNERTGL_BANNERTGL",
    data:{
      "ly":'index'
    },
    method: "post",
  }).then((res)=>{
    if(res.data.code=="000"){
      bannerList.value = res.data.result.filter(item=>item.tp);
    //   bannerList.value = res.data.result[0].tp.split(',')
    }
  }).catch((err)=>{
    console.log(err)
  })
}
onMounted(() => {
  getWdhx()
  getServerList()
  getLink(3)
  getBanner()
})
</script>
<style lang="less">
.index_h5 {
  height: 100%;
  background-color: #F4F4F4;
}

/* Flex布局基础样式 */
.flex-row {
  display: flex;
  flex-direction: row;
}

.flex-col {
  display: flex;
  flex-direction: column;
}

/* 主轴对齐方式 */
.justify-start {
  justify-content: flex-start;
}

.justify-between {
  justify-content: space-between;
}

.line-height-2 {

  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}

.image-wrapper_1 {
  box-shadow: 0px 1px 0px 0px rgba(220, 222, 221, 1);
  background-color: rgba(255, 255, 255, 1);
  width: 100%;
  justify-content: flex-center;
  padding: 10px 14px 9px 14px;
  position: fixed;
  height: 44px;
  z-index: 1000;

  .image_2 {
    width: 201px;
    height: 25px;
  }

  .thumbnail_5 {
    width: 16px;
    height: 16px;
    margin: 4px 0 5px 102px;
  }

  .thumbnail_6 {
    width: 16px;
    height: 12px;
    margin: 6px 0 7px 12px;
  }
}

.tellUs_icon {
  position: fixed;
  width: 52px;
  height: 52px;
  bottom: 66px;
  right: 6px;
  z-index: 1000;
}

.mouse_icon_wrapper {
  position: fixed;
  width: 100vw;
  height: 23px;
  bottom: 30px;
  text-align: center;
  z-index: 1000;
}

.mouse_icon {
  width: 10px;
  height: 23px;
}

.section_1_1 {
  width: 100%;
  padding-top: 44px;

  .page {
    position: relative;
    width: 100%;
    overflow: hidden;
    padding: 14px 14px 0;
  }
  .my-banner-swiper{
    height: 50vw;
    width: 100%;
  }
  .swiperBack {
    width: 100%;
    height: 100%;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    border-radius: 20px;
    img{
      height: auto;
      width: 80%;
    }
  }


  .block_1 {
    position: relative;
  }

  /* 导航栏容器 */
  .nav {
    display: flex;
    /* 横向排列子元素 */
    gap: 20px;
    /* 菜单项之间的间距，可根据需求调整 */
    padding: 0 0 20px;
    /* 容器上下内边距，增强视觉效果 */
    margin: 14px auto 0;
  }

  /* 菜单项通用样式 */
  .nav span {
    text-decoration: none;
    /* 移除默认下划线 */
    color: #333;
    /* 文字颜色，可根据需求调整 */
    font-size: 12px;
    /* 文字大小，可根据需求调整 */
    position: relative;
    /* 为下划线绝对定位做准备 */
    padding-bottom: 14px;
    /* 给下划线预留空间 */
    cursor: pointer;
  }

  /* 选中态下划线 */
  .nav span.active,
  .nav span:hover {
    /* 可选： hover 时也显示下划线，增强交互 */
    color: #000;
    font-weight: 600;
    /* 选中时文字颜色加深，可根据需求调整 */
  }

  .nav span.active::after,
  .nav span:hover::after {
    content: "";
    /* 伪元素必须有 content */
    position: absolute;
    left: 25%;
    bottom: 0;
    width: 50%;
    height: 2px;
    /* 下划线高度，可根据需求调整 */
    background-color: #000;
    /* 下划线颜色，可根据需求调整 */
  }

  .image-wrapper_1 {
    box-shadow: 0px 1px 0px 0px rgba(220, 222, 221, 1);
    background-color: rgba(255, 255, 255, 1);
    width: 100%;
    justify-content: flex-center;
    padding: 10px 14px 9px 14px;
  }

  .image_2 {
    width: 201px;
    height: 25px;
  }

  .thumbnail_5 {
    width: 16px;
    height: 16px;
    margin: 4px 0 5px 102px;
  }

  .thumbnail_6 {
    width: 16px;
    height: 12px;
    margin: 6px 0 7px 12px;
  }

  .text_4 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 18px;
    font-family: AlibabaPuHuiTi_2_95_ExtraBold;
    font-weight: normal;
    text-align: left;
    white-space: nowrap;
    line-height: 28px;
    align-self: center;
    margin-top: 26px;
    font-weight: bold;
  }

  .text-wrapper_8 {
    width: 315px;
    align-self: center;
    margin-top: 14px;
  }

  .text_5 {
    overflow-wrap: break-word;
    color: rgba(25, 25, 25, 1);
    font-size: 12px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
  }

  .text_6 {
    overflow-wrap: break-word;
    color: rgba(25, 25, 25, 1);
    font-size: 12px;
    font-weight: normal;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
    margin-left: 19px;
  }

  .text_7 {
    overflow-wrap: break-word;
    color: rgba(25, 25, 25, 1);
    font-size: 12px;
    font-weight: normal;
    text-align: left;
    white-space: nowrap;
    line-height: 17px;
    margin-left: 19px;
  }

  -text_8 {
    width: 295px;
  }

  -text_9 {
    width: 247px;
  }

  .section_1 {
    background-color: rgba(25, 25, 25, 1);
    width: 24px;
    height: 3px;
    margin: 7px 309px 0 42px;
  }

  .hxywbk_list {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .section_2 {
    border-radius: 16px;
  }

  .image-text_8 {
    background-color: #fff;
    padding: 14px 26px 14px 14px;
    border-radius: 16px;
  }

  .label_1 {
    width: 28px;
    height: 28px;
    margin-bottom: 15px;
  }

  .text-group_13 {
    margin-left: 15px;
    flex: 1;
  }

  .card-action {
    margin-top: 5px;
    display: flex;
    gap: 20px;

    span {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 10px;
      color: #1663FF;
      line-height: 18px;
      text-align: left;
      font-style: normal;
    }
  }

  .text_10 {
    height: 20px;
    font-family: AlibabaPuHuiTi_2_85_Bold;
    font-size: 14px;
    color: #191919;
    line-height: 20px;
    text-align: left;
    font-style: normal;
    font-weight: 600;
  }

  .text_11 {
    overflow-wrap: break-word;
    color: rgba(102, 102, 102, 1);
    font-size: 12px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    line-height: 18px;
    margin-top: 5px;
  }

  .text_12 {
    overflow-wrap: break-word;
    color: rgba(22, 99, 255, 1);
    font-size: 10px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 18px;
    margin: 5px 212px 0 43px;
  }


  .image-text_9 {
    width: 247px;
  }

  .label_2 {
    width: 28px;
    height: 28px;
    margin: 4px 0 34px 0;
  }

  .text-group_14 {}

  .text_13 {
    overflow-wrap: break-word;
    color: rgba(25, 25, 25, 1);
    font-size: 14px;
    font-family: AlibabaPuHuiTi_2_85_Bold;
    font-weight: normal;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    margin-right: 148px;
  }

  .text_14 {
    overflow-wrap: break-word;
    color: rgba(102, 102, 102, 1);
    font-size: 12px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 18px;
    margin-top: 5px;
  }

  .text_15 {
    overflow-wrap: break-word;
    color: rgba(22, 99, 255, 1);
    font-size: 10px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 18px;
    margin: 5px 164px 0 0;
  }

  .image_3 {
    position: absolute;
    left: 332px;
    top: 17px;
    width: 12px;
    height: 76px;
  }

  .section_4 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 16px;
    margin: 10px 20px 0 21px;
    padding: 14px 85px 14px 14px;
  }

  .image-text_10 {
    width: 235px;
  }

  .label_3 {
    width: 28px;
    height: 28px;
    margin-bottom: 38px;
  }

  .text-group_15 {}

  .text_16 {
    overflow-wrap: break-word;
    color: rgba(25, 25, 25, 1);
    font-size: 14px;
    font-family: AlibabaPuHuiTi_2_85_Bold;
    font-weight: normal;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    margin-right: 68px;
  }

  .text_17 {
    overflow-wrap: break-word;
    color: rgba(102, 102, 102, 1);
    font-size: 12px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 18px;
    margin-top: 5px;
  }

  .text_18 {
    overflow-wrap: break-word;
    color: rgba(22, 99, 255, 1);
    font-size: 10px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 18px;
    margin: 5px 152px 0 0;
  }

  .section_5 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 16px;
    width: 334px;
    margin: 10px 20px 0 21px;
    padding: 14px 237px 14px 14px;
  }

  .label_4 {
    width: 28px;
    height: 28px;
    margin-bottom: 38px;
  }

  .text-group_16 {}

  .text_19 {
    overflow-wrap: break-word;
    color: rgba(25, 25, 25, 1);
    font-size: 14px;
    font-family: AlibabaPuHuiTi_2_85_Bold;
    font-weight: normal;
    text-align: left;
    white-space: nowrap;
    line-height: 20px;
    margin-right: 33px;
  }

  .text_20 {
    overflow-wrap: break-word;
    color: rgba(102, 102, 102, 1);
    font-size: 12px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 18px;
    margin: 5px 32px 0 0;
  }

  .text_21 {
    overflow-wrap: break-word;
    color: rgba(22, 99, 255, 1);
    font-size: 10px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 18px;
    margin-top: 5px;
  }

  .image_4 {
    width: 10px;
    height: 23px;
    align-self: center;
    margin-top: 91px;
  }

  .label_5 {
    position: absolute;
    left: 323px;
    top: 549px;
    width: 38px;
    height: 38px;
  }

}

.section_2_2 {
  width: 100%;
  // padding-top: 26px;

  .page {
    background-color: rgba(244, 244, 244, 1);
    position: relative;
    width: 100%;
    // height: 724px;
    overflow: hidden;
  }

  .customers_list {
    padding: 0 14px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .image-wrapper_1 {
    box-shadow: 0px 1px 0px 0px rgba(220, 222, 221, 1);
    background-color: rgba(255, 255, 255, 1);
    width: 100%;
    justify-content: flex-center;
    padding: 10px 14px 9px 14px;
  }

  .image_2 {
    width: 201px;
    height: 25px;
  }

  .thumbnail_5 {
    width: 16px;
    height: 16px;
    margin: 4px 0 5px 102px;
  }

  .thumbnail_6 {
    width: 16px;
    height: 12px;
    margin: 6px 0 7px 12px;
  }

  .text_4 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 18px;
    font-family: AlibabaPuHuiTi_2_95_ExtraBold;
    font-weight: normal;
    text-align: left;
    white-space: nowrap;
    line-height: 28px;
    align-self: center;
    margin: 26px 0 14px;
    font-weight: bold;
  }

  .list_4 {
    height: 416px;
    margin: 14px 13px 0 14px;
  }

  .image-text_1 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 16px;
    position: relative;
    width: 100%;
    height: 132px;
    margin: 0 1px 10px 0;
    padding: 19px 16px 14px 16px;
  }

  .text-group_7 {}

  .text_5 {
    width: 148px;
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 15px;
    font-family: AlibabaPuHuiTi_2_95_ExtraBold;
    font-weight: normal;
    text-align: left;
    white-space: nowrap;
    line-height: 21px;
    margin-right: 72px;
  }

  .text_6 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 12px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    text-align: left;
    white-space: nowrap;
    line-height: 14px;
    margin: 5px 157px 0 0;
  }

  .text_7 {
    height: 54px;
    overflow-wrap: break-word;
    color: rgba(92, 92, 92, 1);
    font-size: 12px;
    font-weight: normal;
    text-align: left;
    line-height: 18px;
    margin-top: 5px;
  }

  .group_3 {
    border-radius: 10px;
    // background-image: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/0971b229318f4ed38400c62f9fee65c4_mergeImage.png);
    width: 94px;
    height: 94px;
    margin-bottom: 5px;
  }

  .image_3 {
    position: absolute;
    left: 339px;
    top: 25px;
    width: 12px;
    height: 79px;
  }

  .group_4 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 16px;
    position: relative;
    width: 100%;
    align-self: center;
    padding: 19px 16px 14px;
  }

  .image-text_5 {
    width: 100%;
  }

  .text-group_8 {
    gap: 24px;
    flex: 1;
    margin-right: 16px;
  }

  .text_8 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 15px;
    font-family: AlibabaPuHuiTi_2_95_ExtraBold;
    font-weight: normal;
    text-align: left;
    white-space: nowrap;
    line-height: 21px;
    margin-right: 16px;
    font-weight: bold;
  }

  .text_9 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 12px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    text-align: left;
    white-space: nowrap;
    line-height: 14px;
    margin: 5px 0 5px;
  }

  .text_10 {
    overflow-wrap: break-word;
    color: rgba(92, 92, 92, 1);
    font-size: 12px;
    font-weight: normal;
    text-align: left;
    line-height: 18px;
  }

  .section_1 {
    // background-image: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/fd2b148bffc44be4b06af407ad137162_mergeImage.png);
    border-radius: 10px;
    width: 94px;
    height: 94px;
  }

  .label_2 {
    width: 38px;
    height: 38px;
    margin: 39px 0 17px -23px;
  }

  .image_4 {
    position: absolute;
    left: 169px;
    top: 118px;
    width: 10px;
    height: 23px;
  }

}


.section_4_4 {
  width: 100%;

  // padding-top: 26px;
  .page {
    background-color: rgba(244, 244, 244, 1);
    position: relative;
    width: 100%;
    overflow: hidden;
  }

  .group_4 {}

  .image-wrapper_1 {
    box-shadow: 0px 1px 0px 0px rgba(220, 222, 221, 1);
    background-color: rgba(255, 255, 255, 1);
    width: 100%;
    justify-content: flex-center;
    padding: 10px 14px 9px 14px;
  }

  .image_2 {
    width: 201px;
    height: 25px;
  }

  .thumbnail_5 {
    width: 16px;
    height: 16px;
    margin: 4px 0 5px 102px;
  }

  .thumbnail_6 {
    width: 16px;
    height: 12px;
    margin: 6px 0 7px 12px;
  }

  .group_5 {
    width: 100%;
    margin: 26px 0;
    margin-bottom: 0;
    justify-content: center;
  }

  .text_4 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 18px;
    font-family: AlibabaPuHuiTi_2_95_ExtraBold;
    font-weight: normal;
    text-align: right;
    white-space: nowrap;
    line-height: 28px;
    font-weight: 600;
  }

  .text-wrapper_3 {
    border-radius: 18px;
    border: 1px solid rgba(25, 25, 25, 1);
    width: 72px;
    height: 28px;
    text-align: center;
    line-height: 26px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #191919;
    font-style: normal;

  }

  .text_13 {
    overflow-wrap: break-word;
    color: rgba(25, 25, 25, 1);
    font-size: 10px;
    font-weight: normal;
    text-align: right;
    white-space: nowrap;
    line-height: 14px;
  }

  .group_6 {
    margin: 14px 13px 0 14px;
    display: flex;
    flex-direction: column;
    /* 竖向排列（主轴为垂直方向） */
    gap: 10px;
    /* 元素之间的间距（行间距）为10px */
  }

  .image-text_1 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 16px;
    width: 100%;
    margin-right: 1px;
    padding: 19px 16px 10px 16px;
  }
  .ljxq{
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 10px;
    color: #1663FF;
    line-height: 18px;
    text-align: left;
    font-style: normal;
    margin-top: 10px;
  }
  .text-group_5 {
    margin-top: 1px;
    margin-right: 16px;
  }

  .text_5 {
    height: 40px;
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-family: AlibabaPuHuiTi_2_95_ExtraBold;
    font-weight: normal;
    text-align: left;
    line-height: 20px;
    font-weight: 600;
  }

  .text_6 {
    height: 36px;
    overflow-wrap: break-word;
    color: rgba(92, 92, 92, 1);
    font-size: 12px;
    font-weight: normal;
    text-align: left;
    line-height: 18px;
    margin-top: 17px;
  }

  .group_2 {
    border-radius: 10px;
    // background-image: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/56fe40fdc1b04b17bf02888d7972b271_mergeImage.png);
    width: 94px;
    height: 94px;
    img{
      width: 94px;
      height: 94px;
      border-radius: 10px;
    }
  }

  .image-text_2 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 16px;
    position: relative;
    width: 347px;
    margin: 10px 1px 0 0;
    padding: 19px 15px 19px 16px;
  }

  .text-group_6 {
    margin-top: 1px;
  }

  .text_7 {
    height: 40px;
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-family: AlibabaPuHuiTi_2_95_ExtraBold;
    font-weight: normal;
    text-align: left;
    line-height: 20px;
  }

  .text_8 {
    height: 36px;
    overflow-wrap: break-word;
    color: rgba(92, 92, 92, 1);
    font-size: 12px;
    font-weight: normal;
    text-align: left;
    line-height: 18px;
    margin-top: 17px;
  }

  .group_3 {
    border-radius: 10px;
    // background-image: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/8d24d784297d4dfa8cff72ba28b2b5d4_mergeImage.png);
    width: 94px;
    height: 94px;
  }

  .image_3 {
    position: absolute;
    left: 339px;
    top: 26px;
    width: 12px;
    height: 76px;
  }

  .image-text_3 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 16px;
    width: 347px;
    margin: 10px 0 0 1px;
    padding: 19px 16px 19px 16px;
  }

  .text-group_7 {
    margin-top: 1px;
  }

  .text_9 {
    height: 40px;
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-family: AlibabaPuHuiTi_2_95_ExtraBold;
    font-weight: normal;
    text-align: left;
    line-height: 20px;
  }

  .text_10 {
    flex: 1;
    height: 36px;
    overflow-wrap: break-word;
    color: rgba(92, 92, 92, 1);
    font-size: 12px;
    font-weight: normal;
    text-align: left;
    line-height: 18px;
    margin-top: 17px;
  }

  .box_3 {
    border-radius: 10px;
    // background-image: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/b9b193161e5a49d0b7012bf212eb7c40_mergeImage.png);
    width: 94px;
    height: 94px;
  }

  .section_3 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 16px;
    position: relative;
    // width: 347px;
    margin: 10px 0 0 0;
    padding: 11px 0 19px 16px;
  }

  .image-text_5 {
    width: 316px;
    margin-top: 8px;
  }

  .text-group_8 {
    margin-top: 1px;
    flex: 1;
    margin-right: 16px;
  }

  .text_11 {
    height: 40px;
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 14px;
    font-family: AlibabaPuHuiTi_2_95_ExtraBold;
    font-weight: normal;
    text-align: left;
    line-height: 20px;
    margin-right: 1px;
  }

  .text_12 {
    height: 36px;
    overflow-wrap: break-word;
    color: rgba(92, 92, 92, 1);
    font-size: 12px;
    font-weight: normal;
    text-align: left;
    line-height: 18px;
    margin: 17px 0 0 1px;
  }

  .section_4 {
    // background-image: url(https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/8f1d0fa058ea4277b537958ad05d21de_mergeImage.png);
    border-radius: 10px;
    width: 94px;
    height: 94px;
  }

  .label_1 {
    width: 38px;
    height: 38px;
    margin: 0 0 64px -23px;
  }

  .image_4 {
    position: absolute;
    left: 169px;
    top: 118px;
    width: 10px;
    height: 23px;
  }

}

.section_5_5 {
  width: 100%;

  // padding-top: 26px;
  .page {
    background-color: rgba(244, 244, 244, 1);
    position: relative;
    width: 100%;
    overflow: hidden;

    .partners-grid {
      display: flex;
      flex-wrap: wrap;
      background-color: #fff;
      margin: 0 20px;
      border-radius: 20px;
      .partner-logo {
        border-radius: 10px;
        width: 48%;
        height: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          max-width: 80%;
          max-height: 80%;
        }
      }
    }
  }

  .box_4 {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 16px;
    position: relative;
    margin: 109px 21px 0 20px;
  }

  .image-wrapper_12 {
    width: 334px;
    height: 300px;
    flex-wrap: wrap;
  }

  .image_2 {
    width: 167px;
    height: 100px;
  }

  .image_2:nth-child(2n) {
    margin-right: 0;
  }

  .image_2:nth-last-child(-n + 2) {
    margin-bottom: 0;
  }

  .image-wrapper_13 {
    width: 334px;
    margin-top: 99px;
  }

  .image_3 {
    width: 167px;
    height: 100px;
  }

  .image_4 {
    width: 167px;
    height: 100px;
  }

  .section_5 {
    width: 334px;
  }

  .image-wrapper_7 {
    // background: url(https://lanhu-oss-proxy.lanhuapp.com/SketchPng4cb20b9224e3def6374193922af3f803d22eedb6eb63d58cbeb7ecd6a59187ba) 0px 0px no-repeat;
    background-size: 167px 101px;
  }

  .image_11 {
    width: 10px;
    height: 23px;
    margin: 48px -6px 29px 163px;
  }

  .image_12 {
    width: 167px;
    height: 100px;
  }

  .image_7 {
    position: absolute;
    left: 0;
    top: 299px;
    width: 167px;
    height: 100px;
  }

  .image_8 {
    position: absolute;
    left: 167px;
    top: 299px;
    width: 167px;
    height: 100px;
  }

  .label_1 {
    position: absolute;
    left: 303px;
    top: 440px;
    width: 38px;
    height: 38px;
  }
  
.box_11 {
    width: 100%;
    margin: 26px auto 11px;
    text-align: center;
    font-family: AlibabaPuHuiTi_2_95_ExtraBold;
    font-size: 18px;
    color: #1A1A1A;
    line-height: 28px;
    text-align: left;
    font-style: normal;
    font-weight: 900;
    font-weight: 600;
}
.text_6 {
    overflow-wrap: break-word;
    color: rgba(26, 26, 26, 1);
    font-size: 18px;
    font-family: AlibabaPuHuiTi_2_95_ExtraBold;
    font-weight: normal;
    text-align: left;
    white-space: nowrap;
    line-height: 28px;
    align-self: center;
    font-weight: 600;
}

  

}

// 联系我们
.tell_us_popup {
  gap: 22px;
  padding: 6px 12px 0;
  .tell_us_li{
    gap:14px;
    .image_9{
      width:20px;
      height:20px;
    }
    .text_5{
      font-family: DINAlternate, DINAlternate;
      font-weight: bold;
      font-size: 14px;
      color: #191919;
      line-height: 16px;
      text-align: left;
      font-style: normal;
    }
    .text_6{
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 11px;
      color: #585858;
      line-height: 16px;
      text-align: left;
      font-style: normal;
    }
    .text-group_5{
      gap: 4px;
    }
    .text_7{
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 10px;
      color: #585858;
      line-height: 14px;
      text-align: center;
      font-style: normal;
    }
    .image_10 {
      width: 100px;
      height: 100px;
    }
  }
}
</style>